import {findIndex} from 'lodash'

export default {
  methods: {
    spliceThread (idThread, targetObj) {
      const index = findIndex(targetObj, {id: idThread})
      if (index === -1 || !targetObj.length) return []
      return targetObj.splice(index, 1)
    },
    pushThread (thread, targetObj, push) {
      if (!thread[0] || !targetObj.length) return
      const sortByDate = (a, b) => new Date(b.date) - new Date(a.date)
      targetObj.push(thread[0])
      targetObj.sort(sortByDate)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/changeMailsStore.js